module.exports = __webpack_public_path__ + "static/media/Ritesh.85d3114f.png";